import * as React from 'react';
import { FaChevronDown } from 'react-icons/fa';

export interface IAccordionProps {
  title: string;
  content: any;
  open: boolean;
}

interface AccordionState {
  isActive: boolean;
}

export default class Accordion extends React.Component<IAccordionProps, AccordionState> {
  constructor(props : any){
    super(props);
    this.state={
      isActive: this.props.open
    }
  }
  
  private toggleIsActive = () => {
    this.setState({
      isActive: !this.state.isActive
    })
  }

  public render(): React.ReactElement<IAccordionProps> {
    const {title, content} = this.props;
    return (
      <div className={"accordion"} >
        <div className={"titleWrapper"} onClick={() => this.toggleIsActive()}>
          <label className={"title"}>{title}</label>
          <div className='icon' aria-expanded={!this.state.isActive}>
            <FaChevronDown />
          </div>
        </div>
        <div className={"contentWrapper"} aria-expanded={!this.state.isActive}> 
        {
          content
        }
          
        </div>
      </div>
    );
  }
}
